import { useQuery } from "@tanstack/react-query";
import { getFile } from "../services/api/bucket";
export var useGetFile = function (filePath) {
    return useQuery({
        queryKey: ["get-file", filePath],
        queryFn: function () { return getFile(filePath); },
        enabled: Boolean(filePath),
    });
};
